var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlayButton(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.79232 19.7923C4.79232 11.508 11.508 4.79232 19.7923 4.79232C28.0766 4.79232 34.7923 11.508 34.7923 19.7923C34.7923 28.0766 28.0766 34.7923 19.7923 34.7923C11.508 34.7923 4.79232 28.0766 4.79232 19.7923ZM19.7923 2.70898C10.3574 2.70898 2.70898 10.3574 2.70898 19.7923C2.70898 29.2272 10.3574 36.8757 19.7923 36.8757C29.2272 36.8757 36.8757 29.2272 36.8757 19.7923C36.8757 10.3574 29.2272 2.70898 19.7923 2.70898ZM18.6241 27.7085L27.0981 21.6573C28.378 20.7434 28.378 18.8413 27.0981 17.9274L18.6241 11.8761C17.1073 10.793 15.0007 11.8772 15.0007 13.7411V25.8436C15.0007 27.7074 17.1073 28.7917 18.6241 27.7085Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayButton);
export default __webpack_public_path__ + "static/media/play_button.2be8e1aa5b159b21adde6dd168217ef6.svg";
export { ForwardRef as ReactComponent };